import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SingleSelect } from '@shared/models/question-types/single-select';
import { QuestionBaseComponent } from '../../question-base/question-base.component';
import { SingleSelectDropdownInputComponent } from './single-select-dropdown-input/single-select-dropdown-input.component';

@Component({
  selector: 'app-single-select-dropdown',
  imports: [
    ReactiveFormsModule,
    TranslateModule,
    CommonModule,
    QuestionBaseComponent,
    SingleSelectDropdownInputComponent,
  ],
  templateUrl: './single-select-dropdown.component.html',
  styleUrl: './single-select-dropdown.component.scss',
})
export class SingleSelectDropdownComponent {
  @Input({ required: true }) question!: SingleSelect;
  @Input() control?: any;
  @Input() otherControl?: any;
  @Input() isFirstQuestion: boolean = false;
}
